(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-result-list.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-result-list.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverSearchResultList = Marionette.CollectionView.extend({
    initialize: function() {
      this.listenTo(
        svs.grassroots.collections.my_receivers,
        'remove reset',
        function() {
          this.checkForMyRemovedReceivers();
        }
      );
      this.listenTo(
        svs.grassroots.collections.my_receivers,
        'add reset append',
        function() {
          this.checkForMyReceivers();
        }
      );
    },
    checkForMyRemovedReceivers: function() {
      _.each(
        this.collection.models,
        function(searchResultReceiver) {
          searchResultReceiver.set({ myReceiver: false });
          _.find(
            svs.grassroots.collections.my_receivers.models,
            function(myReceiver) {
              return this.markSearchResultItem(
                searchResultReceiver,
                myReceiver
              );
            }.bind(this)
          );
        }.bind(this)
      );
    },
    markSearchResultItem: function(searchResultReceiver, myReceiver) {
      if (searchResultReceiver.get('id') === myReceiver.get('id')) {
        searchResultReceiver.set({ myReceiver: true });
        return true;
      }
    },
    checkForMyReceivers: function() {
      _.each(
        svs.grassroots.collections.my_receivers.models,
        function(myReceiver) {
          _.find(
            this.collection.models,
            function(searchResultReceiver) {
              return this.markSearchResultItem(
                searchResultReceiver,
                myReceiver
              );
            }.bind(this)
          );
        }.bind(this)
      );
    },

    childView: svs.grassroots.views.SearchResultItem,
    childViewOptions: function(model) {
      return {
        attributes: {
          'aria-expanded': 'false',
          'aria-controls': `grassroots-search-result-${model.id}`,
          'data-index': model.id
        },
        childIndex: model.id,
        className: `search-result-receiver accordion-item js-accordion-item-${model.id} js-accordion-item`,
        tagName: 'li'
      };
    },
    tagName: 'ul',
    className: 'accordion accordion-customer-sport accordion-default receiver-accordion-search-results js-receiver-search-results js-accordion',
    emptyView: svs.grassroots.views.ReceiverSearchEmpty,
    onAttach: function(view) {
      new svs.ui.Accordion({ el: view.el });
    }
  });
})(Backbone, _, svs);



 })(window);